import apiClient from '../../../../api/axios';

/**
 * 加油单图片识别相关 API（前端 - 后端 1:1 映射）。
 *
 * 后端规格：docs/fzx_doc/结算/燃油加油单图片识别/燃油加油单图片识别_功能规格说明书.md
 */

const BASE = '/v1/settlement/fuel-form-images';

export const fuelFormImageApi = {
    /** T12: 批量上传图片（multipart/form-data） */
    upload: (files) => {
        const formData = new FormData();
        files.forEach((f) => formData.append('files', f));
        return apiClient.post(BASE, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    /** T17: 列表 */
    list: (params) => apiClient.get(BASE, { params }),

    /** T17: 详情 */
    detail: (imageId) => apiClient.get(`${BASE}/${imageId}`),

    /** T17: 预览签名 URL（默认 1 小时） */
    signedUrl: (imageId, ttl = 3600) =>
        apiClient.get(`${BASE}/${imageId}/signed-url`, { params: { ttl } }),

    /**
     * 审核确认 = 绑定 FOP 航班（加油单识别航班勾稽 S3）。
     * body: { flight_operation_id: number, field_overrides?: object }
     */
    confirm: (imageId, body) =>
        apiClient.post(`${BASE}/${imageId}/confirm`, body || {}),

    /** T32: 拒绝 */
    reject: (imageId, reason) =>
        apiClient.post(`${BASE}/${imageId}/reject`, { reason }),

    /** T32: 恢复审核（撤销人工拒绝；rejected → pending_extract） */
    recover: (imageId) => apiClient.post(`${BASE}/${imageId}/recover`),

    /**
     * T44: 重新识别（让 worker 再跑一次 VLM；failed_permanent → pending_extract）
     *
     * 与 ``recover`` 故意拆开两个端点：触发场景、审计含义、未来权限粒度都不同。
     * 见 backend/api/v1/settlement/fuel_form_image_routes.py 的 ``/re-extract``。
     */
    reExtract: (imageId) => apiClient.post(`${BASE}/${imageId}/re-extract`),

    /** T44: 批量重新识别（仅 failed_permanent 生效，其余跳过；返回 requeued / skipped / not_found 计数） */
    reExtractBatch: (ids) => apiClient.post(`${BASE}/batch-re-extract`, { ids }),

    /** 已确认记录改绑到另一个 FOP 航班（替代旧 /relink） */
    rebindFlight: (imageId, newFlightOperationId) =>
        apiClient.post(`${BASE}/${imageId}/rebind-flight`, {
            new_flight_operation_id: newFlightOperationId,
        }),

    /** 航班候选搜索（审核界面手动选定 / 改绑航班用） */
    searchFlights: (params) =>
        apiClient.get(`${BASE}/flight-ops/search`, { params }),
};

export default fuelFormImageApi;
